import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

import { getLocalStorage, removeLocalStorage } from "@/utilities/localstorage";

export const baseURL = process.env.REACT_APP_BACK_URL + "/v2";

export const api: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getLocalStorage("token");
  const tokenExpiresAt = getLocalStorage("tokenExpiresAt");
  if (token && tokenExpiresAt) {
    const now = Date.now();
    const expiresAt = parseInt(tokenExpiresAt);

    if (now > expiresAt) {
      removeLocalStorage("token");
      removeLocalStorage("tokenExpiresAt");
      document.location.href = "/login";
      return Promise.reject(new Error("Token expirado"));
    }
  }
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error: { response: AxiosResponse; config: AxiosRequestConfig }) => {
    if (
      error.response?.status === 401 &&
      !error.config?.url?.includes("/auth/login")
    ) {
      removeLocalStorage("token");
      document.location.href = "/login";
    }

    return Promise.reject(error);
  },
);
